import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 5.93945L21.0608 15.0001L20.0001 16.0608L12.0001 8.06077L4.00011 16.0608L2.93945 15.0001L12.0001 5.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTop;
